/**
 * Código automático com prévia (v6, D11): Enter no campo Código vazio mostra o próximo código
 * como "previsto". Nada é reservado: ao salvar, a prévia sem alteração vai como "automático" e
 * o banco atribui o código definitivo (que pode ser outro, se alguém salvar antes).
 */
import type { CodeKind, NextCodePreview } from "@cafegestor/shared";
import { useState } from "react";
import { apiFetch } from "@/lib/api";

export type AutoCode = ReturnType<typeof useAutoCode>;

export function useAutoCode(kind: CodeKind) {
  const [preview, setPreview] = useState<string | null>(null);
  return {
    kind,
    preview,
    /** busca a prévia (sem permissão ou sem rede: fica "automático") */
    fetchPreview: async (): Promise<string | null> => {
      try {
        const r = await apiFetch<NextCodePreview>(`/cadastros/proximo-codigo?tipo=${kind}`);
        setPreview(r.code);
        return r.code;
      } catch {
        return null;
      }
    },
    /** o que enviar: a prévia sem alteração vai vazia (o banco gera o código) */
    forSave: (value: string): string => (preview !== null && value.trim() === preview ? "" : value),
    /** complemento do aviso quando o código salvo não é o previsto */
    note: (saved: string): string =>
      preview !== null && saved !== preview
        ? ` (o ${preview} foi usado por outro cadastro enquanto você preenchia)`
        : "",
  };
}

/** Leva o foco ao próximo campo do formulário (Enter no Código não envia o formulário). */
export function focusNextField(el: HTMLElement | null) {
  const form = el?.closest("form");
  if (!el || !form) return;
  const fields = Array.from(
    form.querySelectorAll<HTMLElement>("input, select, textarea, button"),
  ).filter(
    (x) =>
      !(x as HTMLInputElement).disabled &&
      x.tabIndex >= 0 &&
      (x as HTMLInputElement).type !== "hidden",
  );
  fields[fields.indexOf(el) + 1]?.focus();
}
